import { Component, OnInit, Input } from '@angular/core';
import { DebatesService } from 'core/index';
import { TutorizationQuestionService } from '../../../group-questions/services/tutorization-question.service';

const DISPUTED = 'DISPUTED';
const CANCELLED = 'CANCELLED';
const CERTIFIED = 'CERTIFIED';

@Component({
  selector: 'lms-debates-list-row',
  templateUrl: './debates-list-row.component.html',
  styleUrls: ['./debates-list-row.component.scss']
})
export class DebatesListRowComponent implements OnInit {
  @Input() debate: any;
  public positiveVotePercentage: number;
  public negativeVotePercentage: number;
  public numOpinions: number;
  public status: any;
  public questionInfo: any;

  constructor(public debatesService: DebatesService, public groupQuestionsService: TutorizationQuestionService) {}

  ngOnInit() {
    const computedDebateData = this.debatesService.getComputedDebateData(this.debate);
    const debateQuestion = this.getquestion();
    this.numOpinions = computedDebateData.numOpinions;
    this.positiveVotePercentage = computedDebateData.positiveVotePercentage;
    this.negativeVotePercentage = computedDebateData.negativeVotePercentage;
    this.status = this.getDisputeStatusData(computedDebateData);
  }
  getquestion() {
    return this.groupQuestionsService.getQuestionData(this.debate.groupQuestionId).then((data) => {
      this.questionInfo = data;
    });
  }
  getDisputeStatusData(computedDebateData) {
    const groupQuestionStatus = computedDebateData.groupQuestionStatus;
    let styleClass;
    switch (groupQuestionStatus) {
      case CANCELLED:
        styleClass = 'red-text';
        break;
      case CERTIFIED:
        styleClass = 'green-text';
        break;
      default:
        styleClass = '';
        break;
    }

    const votesDiff = Math.abs(this.positiveVotePercentage - this.negativeVotePercentage);
    const votesStyle = votesDiff >= 0 && votesDiff <= 5 ? 'red-text' : 'base-text';

    return {
      dispute: computedDebateData.debateStatusLabel,
      groupQuestion: computedDebateData.groupQuestionStatusLabel,
      styleClass,
      votesStyle
    };
  }
}
